import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Position} from '../models/position';
import {config} from '../../shared/config';
import {map} from 'rxjs/operators';
import { BaseHttpService } from '../../core/services/base-http.service';
import { StorageService } from '../../core/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class PositionsService extends BaseHttpService {

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  getPositions(ids: number[]): Observable<Position[]> {
    const fields = ['*'];
    const filters = [{name: 'unitIds', value: ids.join('|')}];

    return this.get(config.generateApiUrl('Positions', fields, filters, '2.0')).pipe(
      map((positions) => {
        const ps = positions['data'] || {data: {items: []}};
        return ps.items as Position[];
      })
    );
  }
}
